import type { components } from "@/api-schema";
import { ModelGenerationIdentifierProvider } from "@/api-schema-enums";

type ModelGenerationIdentifier = Pick<components["schemas"]["ModelGenerationIdentifier"], "identifier" | "provider">;

export function getModelGenerationDatId(identifiers?: readonly ModelGenerationIdentifier[] | null): string | undefined {
  return identifiers?.find((identifier) => identifier.provider === ModelGenerationIdentifierProvider.Dat)?.identifier;
}
